<script setup lang="ts">

import {computed} from "vue";

const props = defineProps({
  height: {
    type: Number,
    default: 41
  },
  color: {
    type: String,
    default: '#80BD1C'
  }
})

const height = computed(() => props.height)
const width = computed(() => props.height / 40 * 58)
const color = computed(() => props.color)
</script>

<template>
  <svg :width="width" :height="height" viewBox="0 0 58 40" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;" :fill="color">
    <g transform="matrix(1,0,0,1,-1.094,-10.296)">
        <g>
            <g>
                <path d="M48.094,16.705L6.094,16.705C3.332,16.705 1.094,18.943 1.094,21.705L1.094,24.705L53.094,24.705L53.094,21.705C53.094,18.942 50.855,16.705 48.094,16.705Z" style="fill-rule:nonzero;"/>
              <path d="M1.094,44.703C1.094,47.465 3.332,49.703 6.094,49.703L48.094,49.703C50.856,49.703 53.094,47.465 53.094,44.703L53.094,31.953L1.094,31.953L1.094,44.703ZM45.094,40.703C46.475,40.703 47.594,41.822 47.594,43.203C47.594,44.584 46.475,45.703 45.094,45.703C43.713,45.703 42.594,44.584 42.594,43.203C42.594,41.822 43.713,40.703 45.094,40.703ZM38.969,40.703C40.35,40.703 41.469,41.822 41.469,43.203C41.469,44.584 40.35,45.703 38.969,45.703C37.588,45.703 36.469,44.584 36.469,43.203C36.469,41.822 37.588,40.703 38.969,40.703Z" style="fill-rule:nonzero;"/>
              <rect x="1.094" y="24.705" width="52" height="7.249" style="fill:white;"/>
              <circle cx="38.969" cy="43.203" r="2.5" style="fill:white;"/>
              <circle cx="45.094" cy="43.203" r="2.5" style="fill:white;"/>
            </g>
          <path d="M53.906,10.296L11.906,10.296C9.397,10.296 7.341,12.149 6.981,14.556C7.281,14.5 7.588,14.463 7.906,14.463L49.906,14.463C52.671,14.463 54.906,16.702 54.906,19.463L54.906,42.463C54.906,42.717 54.869,42.961 54.835,43.203C57.15,42.765 58.906,40.739 58.906,38.297L58.906,15.297C58.906,12.537 56.668,10.296 53.906,10.296Z" style="fill-rule:nonzero;"/>
        </g>
    </g>
</svg>
</template>

<style scoped lang="less">

</style>
